/**
 * Workflow Templates API Client
 *
 * Frontend wrapper for platform workflow templates
 * Used for viewing available processing workflows for the organization
 *
 * Note: These are platform-level workflow templates (Library→TX, Proxy Gen, QC Only, etc.)
 * managed by super admin. Org admins can only view their available workflows.
 */

import axios from '@/axios'

export default {
  /**
   * Get all workflow templates available to the current organization
   * Returns only active templates that the org has access to
   */
  async getAvailable() {
    try {
      const response = await axios.get('/api/workflow-templates/available')
      return response.data
    } catch (error) {
      console.error('Get available workflows error:', error)
      throw error
    }
  },

  /**
   * Get workflow options for dropdown menus
   * Returns simplified list with id, code, and name
   */
  async getOptions() {
    try {
      const response = await axios.get('/api/workflow-templates/options')
      return response.data
    } catch (error) {
      console.error('Get workflow options error:', error)
      throw error
    }
  },

  /**
   * Get single workflow template by ID
   * Returns template details if org has access
   */
  async getById(id) {
    try {
      const response = await axios.get(`/api/workflow-templates/${id}`)
      return response.data
    } catch (error) {
      console.error('Get workflow template error:', error)
      throw error
    }
  }
}
